// extracted by mini-css-extract-plugin
module.exports = {"adminFee":"admin-fee-text_adminFee__3DnI7","text-module_disabled":"admin-fee-text_text-module_disabled__KEl0g"};